import { render } from "./Top5.vue?vue&type=template&id=4e7724a2&scoped=true"
import script from "./Top5.vue?vue&type=script&lang=js"
export * from "./Top5.vue?vue&type=script&lang=js"

import "./Top5.vue?vue&type=style&index=0&id=4e7724a2&scoped=true&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7724a2"]])

export default __exports__